import * as React from "react";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";

export function ExistingVehiclesPicker({
  existing,
  selected,
  onPick,
}) {
  const [q, setQ] = React.useState("");
  const selectedVins = new Set((selected ?? []).map((v) => v.vin));
  const filtered = (existing ?? [])
    .filter((v) => !selectedVins.has(v.vin))
    .filter((v) => {
      const hay = `${v.year} ${v.make} ${v.model} ${v.vin} ${v.bodyType} ${v.class}`.toLowerCase();
      return hay.includes(q.toLowerCase());
    });

  return (
    <div className="space-y-3">
      <Input placeholder="Search by make/model/VIN/body/class…" value={q} onChange={(e) => setQ(e.target.value)} />
      {filtered.length === 0 ? (
        <div className="rounded-md border p-4 text-sm text-gray-600">No existing vehicles to show.</div>
      ) : (
        <div className="max-h-96 overflow-auto rounded-md border divide-y">
          {filtered.map((v) => (
            <div key={v.id ?? v.vin} className="p-3 flex items-center justify-between text-sm">
              <div>
                <div className="font-medium">{v.year} {v.make} {v.model}</div>
                <div className="text-xs text-gray-500">VIN {v.vin} — {v.bodyType} — Class {v.class}</div>
              </div>
              <Button size="sm" onClick={() => onPick(v)}>Add</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
